import { create } from 'zustand';
import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';

interface BreadcrumbState {
  breadcrumbs: Array<BreadcrumbItem>;
  setBreadcrumb: (items: Array<BreadcrumbItem>) => void;
  getBreadcrumb: () => Array<BreadcrumbItem>;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set, get) => {
  return {
    breadcrumbs: [],
    setBreadcrumb: (items: Array<BreadcrumbItem>) => {
      return set(() => {
        return { breadcrumbs: items };
      });
    },
    getBreadcrumb: () => {
      return get().breadcrumbs;
    },
  };
});
